export default __webpack_public_path__ + "e3869c7103f7d2080256ed90e405d18d.png";